module.exports = __webpack_public_path__ + "media/images/category/feature/coj_b/coj_b-4-f5b0b457fbab889b2b6868638a3abfd3.jpg";